import { Spinner } from "@patternfly/react-core";

export const KeycloakSpinner = () => (
  <div className="pf-u-text-align-center">
    <Spinner />
  </div>
);
